import { useEffect, useState } from "react";
import "./Projeto.css";
import BannerPaginaInterna from "../BannerPaginaInterna/BannerPaginaInterna.js";
import Projetos from "../Projetos/Projetos.js";
import Contato from "../Contato/Contato.js";
import licenciamento1 from "../../assets/img/projetos/licenciamento1.png";
import licenciamento2 from "../../assets/img/projetos/licenciamento2.png";
import Servicos from "../Servicos/Servicos.js";

function ProjetoLicenciamentoAmbiental() {
  const [openItem, setOpenItem] = useState(1);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const elements = document.querySelectorAll(".scroll-reveal-zoom");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("visible");
        });
      },
      { threshold: 0.2 },
    );

    elements.forEach((el) => observer.observe(el));
    return () => elements.forEach((el) => observer.unobserve(el));
  }, []);

  return (
    <div className="bg-white">
      <BannerPaginaInterna
        tag="Segurança Operacional"
        titulo="Licenciamento Ambiental"
        descricao="Regularizar um empreendimento minerário em operação, com passivos
              ambientais e riscos de embargo, não é apenas uma questão técnica —
              é uma decisão estratégica."
        textoBotao="Solicitar Orçamento"
        rotaBotao="https://wa.me/5532984053160?text=Olá, quero um orçamento para Licenciamento Ambiental"
        mostrarBotaoOutline={true}
        textoBotaoOutline="Fale com Especialista"
        rotaBotaoOutline="https://wa.me/5532984053160?text=Olá, quero falar com um especialista em Licenciamento Ambiental"
      />

      <main className="projetos-page py-5 container">
        <section className="s scroll-reveal-zoom">
          <div className="titulo-bloco">
            <h2>Licenciamento Ambiental em MG</h2>
            <p>
              Como Regularizamos uma Pedreira e Garantimos a Continuidade da
              Operação
            </p>
          </div>

          <div className="scroll-reveal-zoom">
            <p>
              Regularizar um empreendimento minerário em operação, com passivos
              ambientais e riscos de embargo, não é apenas uma questão técnica —
              é uma decisão estratégica. Este case mostra como conduzimos um
              processo completo de{" "}
              <strong>licenciamento ambiental em Minas Gerais</strong>,
              transformando um cenário de irregularidade em uma operação segura,
              regularizada e estruturada.
            </p>

            <p>
              O projeto foi desenvolvido junto à SEMAD Minas Gerais, envolvendo
              uma pedreira de médio porte voltada à produção de brita, que
              enfrentava um dos cenários mais críticos do ponto de vista
              ambiental: operação sem licença vigente, ampliação não autorizada
              e autuações em andamento.
            </p>

            <p>
              Mais do que obter uma licença, o desafio era claro:{" "}
              <strong>
                regularizar o empreendimento sem interromper a operação
              </strong>
              , preservando a viabilidade econômica enquanto atendíamos às
              exigências legais.
            </p>
          </div>

          <section className="images-section scroll-reveal-zoom">
            <div className="container">
              <div className="images-grid">
                <div className="image-card">
                  <img src={licenciamento1} alt="" className="img-fluid" />
                </div>

                <div className="image-card">
                  <img src={licenciamento2} alt="Imagem secundária" />
                </div>
              </div>
            </div>
          </section>

          <div className="case-destaque scroll-reveal-zoom">
            <h5>
              Quando o Licenciamento Ambiental se Torna um Risco Real para o
              Negócio
            </h5>
            <p>
              Antes da nossa atuação, o empreendimento operava sem licença
              ambiental válida, após perda do prazo de renovação e crescimento
              desordenado das atividades. Esse cenário trouxe riscos imediatos
              de embargo, multas e paralisação.
            </p>
            <p>
              Além disso, havia uma fragilidade estrutural significativa na
              gestão ambiental. Não existia controle de resíduos sólidos, os
              sistemas de tratamento de efluentes eram inadequados, não havia
              monitoramento de emissões atmosféricas e as áreas operacionais
              estavam desorganizadas. Também foram identificadas intervenções em
              áreas de preservação permanente sem a devida regularização.
            </p>
            <p>
              Esse é um quadro comum em processos de{" "}
              <strong>regularização ambiental de pedreiras em MG</strong>, onde
              o crescimento da operação não acompanha a estrutura de controle
              ambiental.
            </p>
          </div>

          <div className="case-destaque scroll-reveal-zoom">
            <h5>A Estratégia: Regularizar Sem Parar a operação</h5>
            <p>
              A solução não poderia ser apenas protocolar. Era necessário
              estruturar uma estratégia que equilibrasse exigência técnica,
              legislação ambiental e realidade operacional.
            </p>
            <p>
              A partir disso, conduzimos um processo de{" "}
              <strong>licenciamento ambiental corretivo</strong>, viabilizado
              por meio de um Termo de Ajustamento de Conduta (TAC). Esse
              instrumento foi essencial para permitir que o empreendimento
              continuasse operando enquanto todas as adequações eram realizadas.
            </p>
            <p>
              Paralelamente, estruturamos os estudos ambientais necessários,
              incluindo RCA/PCA e diagnóstico de APP, e conduzimos toda a
              interface técnica com o órgão ambiental, garantindo consistência
              nas informações e segurança no processo.
            </p>
          </div>

          <div className="case-destaque scroll-reveal-zoom">
            <h5>Da Desorganização à Gestão Ambiental Estruturada</h5>
            <p>
              A regularização não se limitou à documentação. Foi necessária uma
              transformação completa da operação.
            </p>

            <p>
              Implantamos um sistema de gestão ambiental com foco em controle,
              rastreabilidade e eficiência. Isso incluiu a estruturação do{" "}
              <strong>Plano de Gerenciamento de Resíduos Sólidos</strong>,
              organização física das áreas operacionais e adequação de pontos
              críticos da operação.
            </p>

            <p>
              A pilha de estéril passou a ser controlada tecnicamente, a
              drenagem pluvial foi reestruturada e foram instalados sistemas
              adequados para tratamento de efluentes, como{" "}
              <strong>caixas separadoras de água e óleo</strong> e{" "}
              <strong>sistema de esgoto sanitário</strong>. Áreas de
              abastecimento e manutenção foram adequadas com sistemas de
              contenção, e o controle de emissões atmosféricas passou a ser
              monitorado de forma sistemática.
            </p>

            <p>
              Além disso, foram implementados{" "}
              <strong>programas contínuos de monitoramento ambiental</strong>,
              garantindo não apenas a obtenção da licença, mas a manutenção da
              conformidade ao longo do tempo.
            </p>
          </div>

          <div className="case-destaque scroll-reveal-zoom">
            <h5>O Resultado: Licença Obtida e Operação Segura</h5>
            <p>
              Ao final do processo, o empreendimento obteve a{" "}
              <strong>Licença de Operação Corretiva</strong>, com regularização
              completa de aproximadamente <strong>20 hectares</strong> e
              resolução de todos os{" "}
              <strong>passivos ambientais identificados</strong>.
            </p>

            <p>
              O prazo total de regularização foi de <strong>12 meses</strong>,
              dentro do período de vigência do <strong>TAC</strong>, sem
              necessidade de <strong>paralisação das atividades</strong>.
            </p>

            <p>
              Mais do que atender à legislação, o projeto trouxe ganhos diretos
              para o negócio. A operação tornou-se{" "}
              <strong>mais organizada, eficiente e segura</strong>, com melhoria
              nas condições de trabalho e maior controle sobre os processos
              produtivos.
            </p>
          </div>

          <div className="case-destaque scroll-reveal-zoom">
            <h5>Por Que Esse Case é Relevante para o Seu Empreendimento</h5>
            <p>
              Este projeto demonstra que o{" "}
              <strong>licenciamento ambiental em Minas Gerais</strong>, mesmo em
              cenários críticos, pode ser conduzido de forma estratégica,
              evitando <strong>paralisações</strong> e{" "}
              <strong>prejuízos</strong>.
            </p>

            <p>
              A regularização de{" "}
              <strong>pedreiras e empreendimentos minerários</strong> exige mais
              do que conhecimento técnico. É necessário{" "}
              <strong>compreender a operação</strong>,{" "}
              <strong>antecipar riscos</strong> e estruturar{" "}
              <strong>soluções viáveis na prática</strong>.
            </p>

            <p>
              É exatamente esse tipo de abordagem que permite transformar um
              problema ambiental em uma <strong>solução estruturada</strong>,
              com <strong>segurança jurídica</strong>,{" "}
              <strong>eficiência operacional</strong> e{" "}
              <strong>sustentabilidade no longo prazo</strong>.
            </p>
          </div>

          <div className="cta-container">
            <div className="cta-text">
              <h3>Precisa regularizar seu empreendimento?</h3>

              <p>
                Se sua empresa enfrenta dificuldades com licenciamento
                ambiental, ampliação sem autorização ou passivos ambientais, é
                possível reverter esse cenário com uma estratégia técnica
                adequada.
              </p>

              <p>
                Atuamos com licenciamento ambiental em Minas Gerais,
                regularização de empreendimentos minerários e estruturação
                completa de sistemas de controle ambiental.
              </p>

              <p>
                Entre em contato e entenda como podemos conduzir o seu processo
                com segurança, agilidade e foco em resultado.
              </p>
            </div>

            <div className="cta-button-wrapper">
              <a
                href="https://wa.me/5532984053160?text=Olá, gostaria de solicitar um orçamento para elaboração de um projeto de licenciamento ambiental"
                target="_blank"
                rel="noopener noreferrer"
                className="cta-button"
              >
                Orçamento
              </a>
            </div>
          </div>
        </section>
      </main>
      <Projetos />
      <Servicos />
      <Contato />
    </div>
  );
}

export default ProjetoLicenciamentoAmbiental;
